<template>
  <div class="photo-detail-box">
    <BreadCrumb v-if="photoDetail.detail" :title="photoDetail.detail.album.title" />
    <header>
      <Card v-if="photoDetail.detail"
            :title="photoDetail.detail.album.title"
            class="detail-card">
        <template v-slot:content>
          <div class="detail">
            <p>{{ photoDetail.detail.album.introduction }}</p>
            <img v-for="(item, index) in photoDetail.detail.album.photos"
                 v-if="index < 3"
                 :src="item.url"
                 :key="item.id" />
          </div>
        </template>
      </Card>
      <Card v-else :title="''" class="detail-card">
        <template v-slot:content>
          <div class="detail">
            <p>暂无详情数据！请检查页面链接地址参数</p>
          </div>
        </template>
      </Card>
      <aside>
        <ModelInfo v-if="photoDetail.detail && photoDetail.detail.album.modelsOfAlbum && photoDetail.detail.album.modelsOfAlbum.length"
                   :info="photoDetail.detail.album.modelsOfAlbum[0].basic"
                   :labels="photoDetail.detail.album.labels"/>
        <Card class="download-card" :title="'赶快扫码下载APP'">
          <template v-slot:content>
            <div class="aside-download">
              <p>模特高清套图、超清视频、真3D、VR尽在尤果APP</p>
              <div class="download-img-box">
                <img class="arrow arrow01" :src="IMG_URL + 'logos/arrow1@2x.png'">
                <img class="download-img" src="https://static.youguoquan.com/common/official-web/images/Common/ugirls-qrcode.png"/>
                <img class="arrow arrow02"  :src="IMG_URL + 'logos/arrow2@2x.png'">
              </div>
              <div>
                <span class="colorful">扫码下载</span>
              </div>
            </div>
          </template>
        </Card>
        <Card :title="'美女图片分类'">
          <template v-if="photoDetail.labels.length" v-slot:content>
            <div class="aside-tag">
              <Tag v-for="tag in photoDetail.labels" :label="tag" :key="tag.id" />
            </div>
          </template>
        </Card>
      </aside>
    </header>
    <TextBar v-if="photoDetail.textBar" :text="photoDetail.textBar" />
    <HoriTitle class="photo-gallery-title" :firstTitle="'最新美女图片'" :secondTitle="'THE LATEST SEXY BEAUTY'" />
    <PhotoGallery :list="photoDetail.albumList" />
  </div>
</template>

<script>
  import BreadCrumb from '@/components/BreadCrumb'
  import Card from '@/components/Card'
  import ModelInfo from '@/components/ModelInfo'
  import PhotoGallery from '@/components/PhotoGallery'
  import HoriTitle from '@/components/HoriTitle'
  import Tag from '@/components/Tag'
  import TextBar from '@/components/TextBar'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      BreadCrumb,
      Card,
      ModelInfo,
      PhotoGallery,
      HoriTitle,
      Tag,
      TextBar
    },
    // 服务器端渲染，预加载专辑详情数据
    asyncData ({ store, route }) {
      return store.dispatch('getDetailById', route.params.contentId)
    },
    computed: {
      ...mapGetters({
        photoDetail: 'photoDetail'
      })
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .photo-detail-box {
    width: 980px;
    margin: 0 auto;
    .photo-gallery-title {
      margin-top: 40px
    }
  }
  header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 20px 0;
    .detail-card {
      flex: 1;
    }
    .detail {
      padding: 10px;
      img {
        width: 600px;
        margin: 0 auto;
      }
      p {
        width: 600px;
        margin: 0 auto;
        font-size: 14px;
        line-height: 28px;
        text-align: left;
        text-indent: 28px;
      }
    }
    aside {
      display: flex;
      flex-direction: column;
      width: 280px;
      margin-left: 20px;
    }
    .download-card {
      margin: 10px 0;
    }
    .aside-download {
      padding: 20px;
      p {
        width: 150px;
        margin: 0 auto;
        font-size: 12px;
        line-height: 24px;
        font-weight: bold;
      }
      .colorful {
        font-size: 16px;
        background-image: linear-gradient(-45deg, #FF2E93, red, #FF2E93, #fff, red, #FF2E93, #fff, #FF2E93);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-background-size: 200% 100%;
        animation: bgp 1s linear infinite;
      }
    }
    .download-img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .download-img {
        width: 150px;
        margin: 0 auto;
        padding: 10px 0;
      }
      .arrow {
        position: relative;
        width: 29px;
      }
      .arrow01 {
        animation: arrow01 400ms linear infinite alternate;
      }
      .arrow02 {
        animation: arrow02 400ms linear infinite alternate;
      }
    }
    .aside-tag {
      padding: 20px;
      text-align: left;
    }
  }

  @-webkit-keyframes bgp {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
  @keyframes bgp {
     0% {
       background-position: 0 0;
     }
     100% {
       background-position: -100% 0;
     }
   }
  @keyframes arrow01 {
    0% { right: 0 }
    100% { right: -15px }
  }
  @keyframes arrow02 {
     0% { right: 0 }
     100% { right: 15px }
   }
</style>



// WEBPACK FOOTER //
// src/views/PhotoDetail.vue